// Remove characters that are known to cause problems when JSON text is
// serialized and later deserialized by consumers.
export function sanitizeTextForJson(input: string): string {
  if (!input) return input;

  // Convert literal backslash sequences (user-typed \n, \r, \t) into real
  // characters so JSON.stringify emits proper escapes (\n, \r, \t).
  let output = input
    .replace(/\\n/g, "\n")
    .replace(/\\r/g, "\r")
    .replace(/\\t/g, "\t");

  // Normalize line endings.
  output = output.replace(/\r\n?/g, "\n");

  // Replace Unicode line/paragraph separators with a normal newline.
  output = output.replace(/[\u2028\u2029]/g, "\n");

  // Remove ASCII control characters except tab/newline.
  output = output.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, "");

  return output;
}
